import { boxed } from '@sso/shared/hocs';

const Box = boxed('div');
const Form = boxed('form');

type EnhancedBox = typeof Box & {
    Form: typeof Form;
};

(Box as EnhancedBox).Form = Form;

export default Box as EnhancedBox;
